(function () {
    'use strict';

    angular.module('blocks.authentication')
    .provider('currentUser', currentUserProvider)
    .constant('strategies', permissionStrategies);

    function currentUserProvider() {
        var user = {};

        return {
            $get: getProfile
        };

        /* @ngInject */
        function getProfile(atac_page_settings, jwtHelper, userService, $q) {
            if (!!atac_page_settings.security.bearerToken()) {
                user = jwtHelper.decodeToken(atac_page_settings.security.bearerToken());
                getUserSettings();
            } else {
                user = { roles: [], userSettings: {} };
            }
            user.isInRole = isInRole;
            user.getUserId = getUserId;
            user.getUserSettings = getUserSettings;

            return user;

            function getUserSettings() {
                if (!!user.userSettings) {
                    return $q.when(user.userSettings);
                }

                return userService.getUser(getUserId()).then(function (result) {
                    if (!!result) {
                        user.userSettings = result.UserSettings;
                        user.ConnectionTypeId = result.ConnectionTypeId;
                        return result.UserSettings;
                    }
                    return {};
                });
            }
        }

        function isInRole(role) {
            return !!user && user.roles.indexOf(role) > -1;
        }

        function getUserId() {
            return !!user && user.psid;
        }
    }

    function permissionStrategies() {
        return {
            enableElement: function ($element) {
                $element.removeAttr('disabled');
            },
            disableElement: function ($element) {
                $element.attr('disabled', 'disabled');
            },
            enableUIDropdown: function ($element) {
                $element.scope().$select.disabled = false;
            },
            disableUIDropdown: function ($element) {
                $element.scope().$select.disabled = true;
            },
            showElement: function ($element) {
                $element.removeClass('ng-hide');
            },
            hideElement: function ($element) {
                $element.addClass('ng-hide');
            }
        };
    }
})();
